// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NewsCard_wrapper__1jyBh","title":"NewsCard_title__3v5HU","image":"NewsCard_image__2fqaE","date":"NewsCard_date__VLkbC"};